import classNames from 'classnames';
import { useMemo } from 'react';
import { useIssuerGetIssuedCapitalSummaryQuery } from '@/modules/issuer-dashboard/queries/dashboard.ts';
import { AnimatedNumber, Skeleton } from 'ui';

export const IssuerSecuritiesBalanceStatistics = () => {
  const { data: dataCapitalSummary, isFetching } = useIssuerGetIssuedCapitalSummaryQuery();

  const { total, invested, distributed } = useMemo(() => {
    const invested =
      dataCapitalSummary?.data?.find(item => item.type === 'Applications')?.value ?? 0;
    const total = dataCapitalSummary?.data?.find(item => item.type === 'Implied Value')?.value ?? 0;
    const distributed =
      dataCapitalSummary?.data?.find(item => item.type === 'DRP/Reinvestment')?.value ?? 0;

    return { invested, total, distributed };
  }, [dataCapitalSummary]);

  return (
    <div
      className={classNames(
        'w-full flex items-center justify-between',
        'border border-gray-200 rounded-xl md:flex-nowrap flex-wrap',
      )}
    >
      <div className="flex flex-col gap-2 py-3 px-3 sm:px-6 w-[33.3%] min-w-[160px]">
        <p className="text-xs leading-5 text-[#737373]">Invested</p>
        {isFetching ? (
          <Skeleton width={'70%'} height={28} />
        ) : (
          <div className="text-[18px] leading-5 sm:text-xl sm:leading-7 text-[#171717] flex items-center">
            <p>$</p>
            {invested < 0 ? '-' : ''}
            <AnimatedNumber includeComma animateToNumber={Math.round(invested * 100) / 100} />
          </div>
        )}
      </div>
      <div
        className={
          'flex flex-col gap-2 py-3 px-3 sm:px-6 w-[33.3%] min-w-[160px] ' +
          'border-0 md:border-l border-gray-200'
        }
      >
        <p className="text-xs leading-5 text-[#737373]">Distributed</p>
        {isFetching ? (
          <Skeleton width={'70%'} height={28} />
        ) : (
          <div className="text-[18px] leading-5 sm:text-xl sm:leading-7 text-[#171717] flex items-center">
            <p>$</p>
            {distributed < 0 ? '-' : ''}
            <AnimatedNumber includeComma animateToNumber={Math.round(distributed * 100) / 100} />
          </div>
        )}
      </div>
      <div
        className={
          'flex flex-col gap-2 py-3 px-3 sm:px-6 w-[33.3%] min-w-[160px] ' +
          'border-0 md:border-l border-gray-200'
        }
      >
        <p className="text-xs leading-5 text-[#737373]">Current asset value</p>
        {isFetching ? (
          <Skeleton width={'70%'} height={28} />
        ) : (
          <div className="text-[18px] leading-5 sm:text-xl sm:leading-7 text-[#171717] flex items-center">
            <p>$</p>
            {total < 0 ? '-' : ''}
            <AnimatedNumber includeComma animateToNumber={Math.round(total * 100) / 100} />
          </div>
        )}
      </div>
    </div>
  );
};
